import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'ListReportData';

  static fields = {
    id: attr(),
    year: attr(),
    month: attr(),
    closed: attr({
      getDefault: () => false,
    }),
    closedAt: attr(),
    employeeLevel: attr(),
    employeeLevels: attr(),
    listId: fk({
      to: 'List',
      as: 'list',
      relatedName: 'listReportDatas',
    }),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'listReportDatas',
    }),
    createdAt: attr(),
    updatedAt: attr(),
  };

  static reducer({ type, payload }, ListReportData) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        ListReportData.all().delete();

        if (payload.listReportDatas) {
          console.log('[ListReportData] SOCKET_RECONNECT_HANDLE upsert:', payload.listReportDatas.length);
          payload.listReportDatas.forEach((listReportData) => {
            ListReportData.upsert(listReportData);
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.listReportDatas) {
          console.log('[ListReportData] CORE_INITIALIZE upsert:', payload.listReportDatas.length);
          payload.listReportDatas.forEach((listReportData) => {
            ListReportData.upsert(listReportData);
          });
        }

        break;
      case ActionTypes.LIST_REPORT_DATA_FETCH__SUCCESS: {
        const { listId, item } = payload;

        console.log('[ListReportData] LIST_REPORT_DATA_FETCH__SUCCESS:', {
          listId,
          hasItem: !!item,
          closed: item?.closed,
          year: item?.year,
          month: item?.month,
        });

        if (item) {
          ListReportData.upsert(item);
        }

        break;
      }
      case ActionTypes.LIST_REPORT_DATA_CREATE__SUCCESS:
      case ActionTypes.LIST_REPORT_DATA_UPDATE__SUCCESS:
      case ActionTypes.LIST_REPORT_DATA_UPSERT__SUCCESS:
      case ActionTypes.LIST_REPORT_DATA_COMPLETE__SUCCESS:
      case ActionTypes.LIST_REPORT_DATA_EMPLOYEE_LEVELS_UPDATE__SUCCESS:
      case ActionTypes.LIST_REPORT_DATA_CREATE_HANDLE:
      case ActionTypes.LIST_REPORT_DATA_UPDATE_HANDLE:
        if (payload.item) {
          ListReportData.upsert(payload.item);
        }

        break;
      case ActionTypes.LIST_REPORT_DATA_DELETE__SUCCESS:
      case ActionTypes.LIST_REPORT_DATA_DELETE_HANDLE:
        if (payload.listReportData) {
          const listReportDataModel = ListReportData.withId(payload.listReportData.id);

          if (listReportDataModel) {
            listReportDataModel.delete();
          }
        }

        break;
      default:
    }
  }
}
